<template>
  <div id="ActionAuditReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Action Audit Report</div>
          <div class="web-action-btn btn-groups text-right">
                <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                    <i class="fp-export"></i> Export
                </a>
            </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'actionAuditReport'" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'actionAuditReport'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                  mode="remote"
                  title="Action Audit Report List"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :paginationOptions="{
                      enabled: false,
                      position: 'both',
                      perPage: perPage,
                      dropdownAllowAll: false,
                      setCurrentPage:listCurrentPage,
                      perPageDropdown:dropDownPerPage,
                  }"
                  :search-options="{
                  enabled: false,
                  }"

                  >
                </vue-good-table>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "actionAuditReport",
  metaInfo() {
            return {title: "Action Audit Report | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action: 'list',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns: [
                {
                    label: 'Audit Action',
                    field: 'audit_code',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true

                },
                {
                    label: 'Audit Description',
                    field: 'audit_description',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: false,
                    sortable: false

                },
                {
                    label: 'Audit Action Reason',
                    field: 'audit_reason',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true

                },
                {
                    label: 'Source Document Type',
                    field: 'source',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true

                },
                {
                    label: 'Source Document Number',
                    field: 'doc_number',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true
                },
                {
                    label: 'Audit Text',
                    field: 'description',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text"

                },
                {
                    label: 'Audit Text 2',
                    field: 'other_description',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true

                },
                {
                    label: 'Customer Number',
                    field: 'customer_number',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text"

                },
                 {
                    label: 'Customer Name',
                    field: 'customer_name',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text"

                },
                {
                    label: 'Faclity ID Code',
                    field: 'location',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true

                },
                {
                    label: 'Comment NNC Header Type',
                    field: 'comment_type',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: false,
                    sortable : false,
                },
                {
                    label: 'Program Create',
                    field: 'program',
                    fpFieldType:"text",
                    hidden:false,
                    type:'number',
                    filterable: false,
                     sortable: false
                },
                {
                    label: 'User ID Create',
                    field: 'created_by',
                    fpFieldType:"text",
                    hidden:false,
                    type:'number',
                    filterable: true

                },
                {
                    label: 'Date Created',
                    field: 'created_at',
                    fpFieldType:"date",
                    hidden:false,
                    type:'number',
                    filterable: true,
                    sortable : true,
                },
                {
                    label: 'Time Created',
                    field: 'created_time',
                    fpFieldType:"date",
                    hidden:false,
                    type:'number',
                    filterable: false,
                    sortable : false,
                },
                {
                    label: 'Unit Number',
                    field: 'unit_no',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text",
                    // filterOptions:{
                    //   filterDropdownItems:["Inventory","Sublet","Miscellaneous"]
                    // }
                },
                {
                    label: 'Equipment Type Code',
                    field: 'vehicle_type',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                },
                 {
                    label: 'Equipment Type Description',
                    field: 'vehicle_type_desc',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                },
                {
                    label: 'Time Zone Date',
                    field: 'timezone_date',
                    fpFieldType:"date",
                    hidden:false,
                    filterable: false,
                    sortable:false,
                },
                {
                    label: 'Time Zone Time',
                    field: 'timezone_time',
                    fpFieldType:"date",
                    hidden:false,
                    filterable: false,
                    sortable:false,
                },
            ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'accrued_liability_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    loadList: function(){
      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      $.ajax({
        url: process.env.ROOT_API + "/audit-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action


        },
        success: function(data) {
          self.loading = false;

          if (data.status == "success") {


            if (self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

              self.action = "list";
              // self.loadList();

            } else {
                 if (data.content.row != undefined) {

                  self.rows = data.content.row;
                }

                self.totalRecords = data.content.totalRecords;
            }



          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'audit-report');
        }
      });

    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/ActionAuditReport.vue